// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k57n4","colBig":"styles_colBig__3f_Wl","colSmall":"styles_colSmall__2pjCc"};